//import lightGallery from 'lightgallery';

var tabItinerari = new Swiper(".swiper--itinerari", {
  spaceBetween: 0,
  slidesOffsetAfter: 0,
  slidesOffsetBefore: 0,
  centerInsufficientSlides: true,
  initialSlide: 0,
  loop: false,

  freeMode: {
    enabled: true,
    sticky: false,
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
    },
    0: {
      slidesPerView: "1.3",
    },
  },
});

var tabNewsCategory = new Swiper(".swiper--news-category", {
  spaceBetween: 0,
  slidesOffsetAfter: 0,
  slidesOffsetBefore: 0,
  centerInsufficientSlides: false,
  initialSlide: 0,
  loop: false,
  freeMode: {
    enabled: true,
    sticky: false,
  },
  //slidesPerView: "auto",
  breakpoints: {
    0: {
      slidesPerView: "auto",
    },
  },
});

var swiperCamere = new Swiper(".swiper--camere", {
  spaceBetween: 20,
  slidesOffsetAfter: 20,
  slidesOffsetBefore: 20,
  centerInsufficientSlides: true,
  initialSlide: 0,
  loop: false,
  autoHeight: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
    },
    450: {
      slidesPerView: "auto",
      spaceBetween: 10,
    },
    0: {
      slidesPerView: "1.2",
      spaceBetween: 10,
    },
  },
});

var swiperCarousel = new Swiper(
  ".swiper--offerte, .swiper--news, .swiper--giftVoucher",
  {
    spaceBetween: 20,
    slidesOffsetAfter: 20,
    slidesOffsetBefore: 20,
    centerInsufficientSlides: true,
    initialSlide: 0,
    loop: false,
    autoHeight: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: "auto",
      },
      0: {
        slidesPerView: "auto",
        spaceBetween: 10,
      },
    },
  }
);

var swiperStrutture = new Swiper(".swiper--strutture", {
  spaceBetween: 20,
  slidesOffsetAfter: 20,
  slidesOffsetBefore: 20,
  centerInsufficientSlides: true,
  initialSlide: 0,
  loop: false,
  autoHeight: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
    },
    0: {
      slidesPerView: "auto",
      spaceBetween: 10,
    },
  },
});

var swiperReviews = new Swiper(".swiper--reviews", {
  spaceBetween: 0,
  slidesPerView: 1,
  //centeredSlides: true,
  navigation: {
    nextEl: ".reviews-custom-nav .swiper-button-next",
    prevEl: ".reviews-custom-nav .swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

var swiperSlideshow = new Swiper(".swiper--slideshow", {
  preloadImages: true,
  spaceBetween: 0,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});





jQuery(function ($) {

  // lightgallery
  var galleryContainer = document.querySelectorAll('.swiper--slideshow .swiper-wrapper');

  if ( galleryContainer.length && window.innerWidth < 768 ) {
    galleryContainer.forEach(el => {
      lightGallery(el, {
        selector: '.swiper-slide',
        thumbnail: true,
        controls : false
      });
      
    });
  }

  // Cookies (usato per popup)
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }


  function removeTags(str) {
    if (str === null || str === "" || typeof str == 'undefined') return false;
    else str = str.toString();

    str = str.replace(/(<([^>]+)>)/gi, "");
    str = str.replace(/\s+/g, " ");

    return htmlDecode(str);
  }

  function behindNavbar() {
    var navbar = $("#masthead");
    var main = $("body.home main.main-content");
    var navbarHeight = navbar.outerHeight();

    main.css("top", "-" + navbarHeight + "px");
    main.css("position", "relative");
  }

  if ($("body.home").length) {
    behindNavbar();
  }

  /*
    lightGallery($('.lightgallery'), {
        speed: 500,        
    });*/

  // gestione popup informativa
  
  var popupInformativaHeight = $(".popup-informativa").outerHeight();
  //al click di hamburger menu nascondo o mostro l'informativa popup, questo perché il modale dell'altro popup è in fixed e diventa innavigabile
  $('input[data-bs-toggle="modal"').click(function () {
    //stiamo chiudendo il menu, quindi MOSTRO l'informativa
    if ($("#primaryMenuModal").is(":visible")) {
      if ($(".popup-informativa").length) {
        $(".popup-informativa").animate(
          {
            height: popupInformativaHeight,
          },
          250
        );
      }
      //stiamo aprendo il menu, quindi NASCONDO l'informativa
    } else {
      $(".popup-informativa").animate(
        {
          height: "0",
        },
        250
      );
    }
  });
  $(".popup-informativa__close").click(function () {
    setCookie("hide-popup-informativa", true, 15);
    $(".popup-informativa").animate(
      {
        height: "0",
      },
      250,
      function () {
        $(".popup-informativa").remove();
      }
    );
  });

  /**/
  /*
    non è stato possibile disattivare lo swiper sul breakpoint,
    questo perché le classi swiper danno comunque uno stile anche se non è stato 'attivato'
    quindi andiamo a sostituire le classi e poi attivarlo in caso di schermi piccoli.
    Inoltre al resize della finestra, se c'è un swiperoff in pagina, si ricarica, così ha tutto effetto.
     */

  if (window.innerWidth < 992) {
    var swiperOffElements = $('[class^="swiperoff"]');
    swiperOffElements.each(function (index) {
      var element = $(this);
      var classes = $(this).attr("class").split(" ");
      $.each(classes, function (index, oneClass) {
        if (oneClass.includes("swiperoff")) {
          var classFixed = oneClass.replace("swiperoff", "swiper");
          element.removeClass(oneClass);
          element.addClass(classFixed);
          console.log(oneClass, classFixed);
        }
      });
    });

    var swiperCarouselCamereOff = new Swiper(
      ".carousel-camere-swiperoff .swiper--camere",
      {
        spaceBetween: 20,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        centerInsufficientSlides: true,
        initialSlide: 0,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: "auto",
          },
          450: {
            slidesPerView: "auto",
            spaceBetween: 10,
          },
          0: {
            slidesPerView: "1.2",
            spaceBetween: 10,
          },
        },
      }
    );
  }

var cachedWidth = $(window).width();
  $(window).resize(function () {
    if (window.innerWidth > 768) {
      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function () {
        var swiperOffElements = $('[class*="swiperoff"]');
        if (swiperOffElements.length) {
          console.log("reload page");
          location.reload();
        } else {
          console.log("NO reload page");
        }
      }, 250);
    }

    // con il popup informativa visibile in pagina dobbiamo ri-configurare la variable altezza del popup varia
    var newWidth = $(window).width();
    if (newWidth !== cachedWidth && $(".popup-informativa").is(":visible")) {
      cachedWidth = newWidth;
      location.reload();
    }
  });

  /* fine gestione swiper breakpoint */

  // gestione classe body quando si è scrollato
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
      //clearHeader, not clearheader - caps H
      $("body").addClass("is-scrolled");
    } else {
      $("body").removeClass("is-scrolled");
    }
  });

  //link in pagina con smooth
  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        { duration: 200, easing: "linear" }
      );
    }
  });

  // scroll anchor link
  $('.anchor-link[data-anchor-link!=""]').on("click", function (event) {
    var target = $(
      '*[data-anchor-reference="' + this.getAttribute("data-anchor-link") + '"]'
    );
    if (target.length) {
      var scrollTo = target.offset().top - $(".site-header").outerHeight();
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: scrollTo,
        },
        { duration: 200, easing: "linear" }
      );
    }
  });

  $("#pills-tab .button").on("click", function () {
    // Ottieni il valore del data-id del pulsante cliccato
    //var importo = $(this).data('id');
    var importo = removeTags($(this).parent().find(".voucher-price").html());
    var title = removeTags($(this).parent().find(".voucher-title").html());

    // Stampalo nell'input del form di contatto
    if ($("#input_gift").length) {
      $("#input_gift").val(importo.trim());
    }
    if ($("#input_title").length) {
      $("#input_title").val(title.trim());
    }

    var target = $("#pills-tabContent");
    var scrollTo = target.offset().top - $(".site-header").outerHeight();
    $("html, body").animate(
      {
        scrollTop: scrollTo,
      },
      { duration: 200, easing: "linear" }
    );
  });

  // itinerari button - scrolla in giù
  $(".itinerari-booking-cta").click(function (event) {
    var target = $("section.custom-shortcode"); // è il form in questa pagina
    var scrollTo = target.offset().top - $(".site-header").outerHeight();
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: scrollTo,
      },
      { duration: 200, easing: "linear" }
    );
  });

  //al primo caricamento di pagina rendo i valori dei tab una select per il form
  if ($("#tab_itinerari").length > 0) {
    $("#tab_itinerari>li").each(function (index) {
      var titolo = $(this).find("span").html();
      // se non ci sono altre option
      if (
        !$('select[name="your-journey"] option[value="' + titolo + '"]').length
      ) {
        $('select[name="your-journey"]').append(
          $("<option>", {
            value: titolo,
            text: titolo,
          })
        );
      }
    });
  }

  // itinerari - button tab - compila il form
  $("#tab_itinerari>li>button").click(function () {
    var titolo = $(this).find("span").html();
    $('select[name="your-journey"]').val(titolo);
  });
  $("#tab_itinerari>li>button.active").trigger("click");
}); // jQuery End
